module.exports = __webpack_public_path__ + "static/media/Cover.fdd33cc6.jpg";